// =============================================================================
// src/data/ai-surfaces/monitoring-surfaces.ts — Superfícies de IA do Monitoramento.
//
// Seção #section-monitoramento (src/views/monitoramento/**). KPIs de sentimento ←
//   monitoring.v_sentiment_24h; insights por filtro ← gold.section_insight.
// =============================================================================

import type { AiSurfaceEntry } from '../ai-surface-types';

export const MONITORING_AI_SURFACES: readonly AiSurfaceEntry[] = [
  {
    id: 'monitoramento.sentimento-kpi',
    label: 'KPI de sentimento',
    domain: 'monitoramento',
    location: 'Seção Monitoramento · KPI "Sentimento"',
    renderRef: 'src/views/monitoramento/index.ts#MONITORAMENTO_MARKUP',
    aiKind: 'sentiment',
    backendLayer: 'camada-2',
    backendSource: { kind: 'hasura-view', name: 'monitoring.v_sentiment_24h' },
    status: 'partial',
    inputs: ['classificação NLP por item (24h)'],
    fields: [
      { uiField: 'mon.sentimento', backendField: 'avg_weighted_score', type: 'number' },
    ],
  },
  {
    id: 'monitoramento.mencoes-kpi',
    label: 'KPI de menções/hora',
    domain: 'monitoramento',
    location: 'Seção Monitoramento · KPI "Menções"',
    renderRef: 'src/views/monitoramento/index.ts#MONITORAMENTO_MARKUP',
    aiKind: 'aggregate',
    backendLayer: 'camada-2',
    backendSource: { kind: 'hasura-view', name: 'monitoring.v_sentiment_24h' },
    status: 'partial',
    inputs: ['volume total de menções 24h'],
    fields: [{ uiField: 'mon.mencoes', backendField: 'total', type: 'number' }],
  },
  {
    id: 'monitoramento.evolucao',
    label: 'Evolução de menções',
    domain: 'monitoramento',
    location: 'Seção Monitoramento · gráfico dual + marcador de evento',
    renderRef: 'src/views/monitoramento/index.ts#MONITORAMENTO_MARKUP',
    aiKind: 'forecast',
    backendLayer: 'camada-2',
    backendSource: { kind: 'hasura-table', name: 'monitoring.topic_signal' },
    status: 'mock',
    inputs: ['velocidade de menções por candidato', 'marcação automática de evento'],
    fields: [
      { uiField: 'mon.evo[].volume', backendField: 'content_count', type: 'number' },
      { uiField: 'mon.evo[].periodo', backendField: 'period_start', type: 'iso-datetime' },
    ],
  },
  {
    id: 'monitoramento.eventos',
    label: 'Tabela de eventos ao vivo',
    domain: 'monitoramento',
    location: 'Seção Monitoramento · tabela filtrável de eventos',
    renderRef: 'src/views/monitoramento/monitoramento-controller.ts#MONITOR_INSIGHT_BY_FILTER',
    aiKind: 'classification',
    backendLayer: 'camada-3',
    backendSource: { kind: 'hasura-table', name: 'monitoring.alert' },
    status: 'mock',
    inputs: ['eventos classificados por criticidade/tipo'],
    fields: [
      { uiField: 'mon.evento.tipo', backendField: 'alert_type', type: 'enum' },
      { uiField: 'mon.evento.severidade', backendField: 'severity', type: 'enum' },
      { uiField: 'mon.evento.texto', backendField: 'title', type: 'string' },
    ],
  },
  {
    id: 'monitoramento.filtro-insight',
    label: 'Insight por filtro',
    domain: 'monitoramento',
    location: 'Seção Monitoramento · narrativa por filtro ativo',
    renderRef: 'src/views/monitoramento/monitoramento-controller.ts#MONITOR_INSIGHT_BY_FILTER',
    aiKind: 'insight',
    backendLayer: 'camada-3',
    backendSource: { kind: 'hasura-table', name: 'gold.section_insight' },
    status: 'mock',
    inputs: ['snapshot por filtro', 'prioridade operacional'],
    fields: [
      { uiField: 'mon.insight.texto', backendField: 'detail', type: 'string' },
    ],
  },
];
